/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useCallback, useEffect, useRef } from "react";

import { WindowLocation } from "@reach/router";
import { AnimatePresence, motion } from "framer-motion";

import "normalize.css";
import "../styles/global.scss";

// import { useAppContext } from "./Context/AppContext";
import {
  registerBootlegVH,
  registerDeviceSniff,
  registerMouseXSlant,
} from "../utils/dom";
import { pageview } from "../utils/analytics";
import { Header } from "./Layout/Header";
import { useAppContext } from "./Context/AppContext";
import { Consent } from "./common/Consent";

interface LayoutProps {
  children: React.ReactNode;
  location: WindowLocation;
}

const duration = 0.5;

const variants = {
  initial: {
    opacity: 0,
  },
  enter: {
    opacity: 1,
    transition: {
      duration: duration,
      delay: duration,
      when: "beforeChildren",
    },
  },
  exit: {
    opacity: 0,
    transition: { duration: duration },
  },
};

const isNotHomePage = (location: WindowLocation) => {
  return location.pathname !== "/";
};

const Layout: React.FC<LayoutProps> = ({ children, location }) => {
  const { navOpen, setNavOpen, setAnimating, animating } = useAppContext();
  const pathnameRef = useRef("");

  useEffect(() => {
    registerDeviceSniff();
    registerBootlegVH();
    registerMouseXSlant();
  }, []);

  useEffect(() => {
    setAnimating(true);
    pathnameRef.current = location.pathname;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        pageview(location.pathname);
      });
    });
  }, [location.pathname, setAnimating]);

  const onAnimationComplete = useCallback(
    pathname => {
      setAnimating(!(pathnameRef.current === pathname));
    },
    [setAnimating]
  );

  return (
    <>
      <Header
        navOpen={navOpen}
        setNavOpen={setNavOpen}
        display={isNotHomePage(location)}
      />

      <AnimatePresence>
        <motion.main
          key={location.pathname}
          variants={variants}
          initial="initial"
          animate="enter"
          exit="exit"
          onAnimationComplete={() => onAnimationComplete(location.pathname)}
        >
          {children}
        </motion.main>
      </AnimatePresence>

      <Consent />
    </>
  );
};

export { Layout };
